/* Ryedical — July redesign homepage interactions.
   Loaded globally from theme.liquid. Event-delegated + guarded so it works
   for every ryedical-home-* section and survives Theme Editor re-renders.

   Handles:
   - Benefit card tap-to-flip      ([data-ry-flip] inside [data-ry-flip-card])
   - "What's inside" carousel arrows ([data-ry-carousel] + prev/next buttons)
   - FAQ accordion                 ([data-ry-faq-q] inside [data-ry-faq-item])

   Scroll-reveal is handled by the existing data-animate / is-visible system
   in ryedical-animations.js, so it is intentionally NOT duplicated here. */
(function () {
  'use strict';

  /* ---------------- Benefit card flip ---------------- */
  function toggleFlip(card) {
    if (!card) return;
    var flipped = card.classList.toggle('is-flipped');
    var trigger = card.querySelector('[data-ry-flip]');
    if (trigger) trigger.setAttribute('aria-pressed', flipped ? 'true' : 'false');
  }

  document.addEventListener('click', function (e) {
    var flip = e.target.closest ? e.target.closest('[data-ry-flip]') : null;
    if (flip) {
      toggleFlip(flip.closest('[data-ry-flip-card]'));
      return;
    }

    /* ---------------- Carousel arrows ---------------- */
    var arrow = e.target.closest ? e.target.closest('[data-ry-carousel-prev],[data-ry-carousel-next]') : null;
    if (arrow) {
      var section = arrow.closest('[data-ry-inside]') || document;
      var track = section.querySelector('[data-ry-carousel]');
      if (track) {
        var card = track.querySelector('[data-ry-card]');
        var step = card ? card.getBoundingClientRect().width + 12 : 230;
        var dir = arrow.hasAttribute('data-ry-carousel-next') ? 1 : -1;
        track.scrollBy({ left: dir * step, behavior: 'smooth' });
      }
      return;
    }

    /* ---------------- FAQ accordion ---------------- */
    var q = e.target.closest ? e.target.closest('[data-ry-faq-q]') : null;
    if (q) {
      var item = q.closest('[data-ry-faq-item]');
      if (item) {
        var open = item.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    }
  });

  /* Keyboard support for the flip cards (they are role="button"). */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var flip = e.target.closest ? e.target.closest('[data-ry-flip]') : null;
    if (!flip) return;
    e.preventDefault();
    toggleFlip(flip.closest('[data-ry-flip-card]'));
  });
})();
